/**
 * Site QA — Grok authors boxes, owner approves, runner checks them off.
 * Fail handoff: PNG that shows the error + screenshot path + job brief to Grok.
 */

export type QaAuthor = "grok" | "owner";

export type QaItemStatus =
  | "pending"
  | "generated"
  | "running"
  | "pass"
  | "fail"
  | "waiting-fix";

export type QaActionType = "goto" | "click" | "type" | "expectText" | "expectVisible" | "wait";

export type QaAction = {
  type: QaActionType;
  url?: string;
  selector?: string;
  text?: string;
  ms?: number;
};

export type QaItem = {
  id: string;
  title: string;
  /** How to exercise the box in the browser. */
  actions: QaAction[];
  authoredBy: QaAuthor;
  /** Owner must tick this before Generate / Run may touch the box. */
  approved: boolean;
  status: QaItemStatus;
  /** Fail screenshot path posted to the inbox and the fixer Grok prompt. */
  screenshotPath?: string;
  lastFailAt?: string;
  passAt?: string;
  retries: number;
};

export type QaTask = {
  itemId: string;
  title: string;
  actions: QaAction[];
};

export type QaSession = {
  id: string;
  targetUrl: string;
  /** Repo the fixer Grok window opens in (the site under test). */
  repoPath: string;
  items: QaItem[];
  tasks: QaTask[];
  generatedAt?: string;
  running: boolean;
  sidecarSessionId?: string;
};

export const QA_MAX_RETRIES = 5;
export const QA_SIDECAR_DEFAULT = "http://127.0.0.1:5193";
